import React from 'react';
import './Shop.css';

const products = [
  { id:1, name:'TPG Starter Pack', desc:'Everything you need to start your patch journey. Includes a starter binder, dividers, and 3 exclusive TPG patches.', price:'$24.99', badge:'Best Seller', icon:'🎒', color:'var(--gold)' },
  { id:2, name:'Patch Binder — Pro', desc:'Premium 3-ring binder with custom TPG branding, clear sleeves for up to 60 patches, and a name tag window.', price:'$34.99', badge:null, icon:'📚', color:'var(--blue)' },
  { id:3, name:'TPG Patch Sleeves (50 pack)', desc:'Crystal-clear acid-free patch sleeves designed to protect and display your patches. Universal fit.', price:'$12.99', badge:null, icon:'✨', color:'var(--purple)' },
  { id:4, name:'Exclusive TPG Patch Set', desc:'Limited edition set of 5 exclusive The Patch Guys patches — not available anywhere else.', price:'$19.99', badge:'Limited', icon:'🏅', color:'var(--gold)' },
  { id:5, name:'TPG Hat', desc:'Structured snapback hat with embroidered TPG logo. One size fits most. Available in Navy/Gold.', price:'$29.99', badge:'New', icon:'🧢', color:'var(--navy)' },
  { id:6, name:'Team Patch Display Frame', desc:'Wall-mountable display frame holds up to 24 patches. Perfect for showing off your collection at home.', price:'$44.99', badge:null, icon:'🖼️', color:'var(--blue)' },
];

export default function Shop() {
  return (
    <div className="shop">
      <section className="shop__hero">
        <div className="container">
          <div className="badge badge-gold" style={{marginBottom:'20px'}}>Official Merchandise</div>
          <h1 className="section-title animate-fade-up" style={{color:'white', marginBottom:'16px'}}>The Patch Guys Shop</h1>
          <p className="animate-fade-up delay-1" style={{color:'rgba(255,255,255,0.65)', fontSize:'17px', maxWidth:'500px', margin:'0 auto', textAlign:'center', lineHeight:'1.7'}}>
            Binders, sleeves, and exclusive patches to display your collection in style.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="shop__coming-soon">
            <div className="shop__coming-soon-icon">🚧</div>
            <h2>Shop Coming Soon</h2>
            <p>
              We're working on building out our full merchandise store.
              Sign up below to get notified when we launch!
            </p>
            <form className="shop__notify-form" onSubmit={e => { e.preventDefault(); alert('Thanks! We\'ll let you know when the shop launches.'); }}>
              <input type="email" required placeholder="your@email.com" className="form-input shop__notify-input" />
              <button type="submit" className="btn btn-primary">Notify Me</button>
            </form>
          </div>

          <div className="shop__preview-label">
            <span>Preview — Coming Soon</span>
          </div>

          <div className="shop__grid">
            {products.map(p => (
              <div key={p.id} className="shop-card">
                {p.badge && <div className="shop-card__badge" style={{background: p.color === 'var(--navy)' ? 'var(--navy)' : p.color}}>{p.badge}</div>}
                <div className="shop-card__icon" style={{background:`${p.color}15`, border:`1px solid ${p.color}30`}}>
                  <span>{p.icon}</span>
                </div>
                <div className="shop-card__body">
                  <h3 className="shop-card__name">{p.name}</h3>
                  <p className="shop-card__desc">{p.desc}</p>
                  <div className="shop-card__footer">
                    <span className="shop-card__price">{p.price}</span>
                    <button className="btn shop-card__btn" disabled>Coming Soon</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
